export const PET_WEIGHT_OPTION_ITEM_NONE = 1000;

const petWeightOptionItems = [
  {
    label: 'Small (under 20 lbs.)',
    value: 20,
  },
  {
    label: 'Medium (under 35 lbs.)',
    value: 35,
  },
  {
    label: 'Large (under 50 lbs.)',
    value: 50,
  },
  {
    label: 'Extra Large (under 75 lbs.)',
    value: 75,
  },
  {
    label: 'No Weight Limit',
    value: PET_WEIGHT_OPTION_ITEM_NONE,
  },
];

export default petWeightOptionItems;
